import { requestJson } from "../api/apiClient";

const BASE = "/api/weather/colombia/risk";

export async function fetchWeatherRiskForPoint({ latitude, longitude, radiusMeters = 2000 }) {
  const params = new URLSearchParams({
    lat: String(latitude),
    lng: String(longitude),
    radiusMeters: String(radiusMeters),
  });
  return requestJson(`${BASE}/point?${params.toString()}`);
}

export async function fetchWeatherRiskForViewport(bbox, radiusMeters) {
  const params = new URLSearchParams({ bbox: bbox.join(",") });
  if (radiusMeters != null) {
    params.set("radiusMeters", String(radiusMeters));
  }
  return requestJson(`${BASE}/viewport?${params.toString()}`);
}

export async function fetchWeatherRiskForProperty(propertyId) {
  return requestJson(`${BASE}/property/${encodeURIComponent(propertyId)}`);
}

export async function fetchWeatherRiskForNeighborhood(neighborhoodId) {
  return requestJson(`${BASE}/neighborhood/${encodeURIComponent(neighborhoodId)}`);
}

export const RISK_LEVEL_LABELS = {
  low: "Low",
  moderate: "Moderate",
  elevated: "Elevated",
  high: "High",
  unknown: "Unknown",
};

export const CONFIDENCE_LABELS = {
  high: "High confidence",
  medium: "Medium confidence",
  low: "Low confidence",
  unknown: "Unknown confidence",
};

export const RAIN_NEARBY_LABELS = {
  none: "None detected",
  light: "Light rain nearby",
  moderate: "Moderate rain nearby",
  heavy: "Heavy rain nearby",
  unknown: "Unknown",
};

export function formatRiskLevel(level) {
  return RISK_LEVEL_LABELS[level] || level || "Unknown";
}

export function formatConfidence(level) {
  return CONFIDENCE_LABELS[level] || level || "Unknown confidence";
}
